
import { PropType, computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { useMainStore } from '@/store/mainStore';
import DriveSharedBar from '@/modules/drive/components/DriveSharedBar.vue';
import { NAVIGATION_PAGES, SHARE_SETTINGS } from '@/types/enums';
import { IMedia } from '@/types/interfaces';

export default defineComponent({
  components: { DriveSharedBar },
  props: {
    title: { type: String, default: '' },
    file: { type: Object as PropType<IMedia>, required: true },
  },
  emits: ['on-click-back', 'on-click-share', 'on-click-dots'],
  setup(props, { emit }) {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const route = useRoute();

    const isNetwork = computed(() => route.meta.isNetwork || false);
    const isMy = computed(() => driveStore.appPhotoViewMedia?.owner?.accountId === mainStore.user.accountId);
    const currentPage = computed(() => (route.meta.navigationPage));

    const isPublicCasesPage = computed(() => currentPage.value === NAVIGATION_PAGES.PUBLIC_CASES || currentPage.value === NAVIGATION_PAGES.USER_PUBLIC_CASES);
    const isUserPublicCase = computed(() => route.meta.isUserPublicCase);
    const isPublicPage = computed(() => route.path.includes('/public/case'));

    const navigationPage = computed(() => route.meta.navigationPage);
    const isCase = computed(
      () => navigationPage.value === NAVIGATION_PAGES.DRIVE_CASES
        || navigationPage.value === NAVIGATION_PAGES.CASE_EDIT
        || navigationPage.value === NAVIGATION_PAGES.CASE_VIEW,
    );
    const toShare = computed(() => (!isNetwork.value && isMy.value)
      || (driveStore.appPhotoViewMedia?.root && driveStore.appPhotoViewMedia?.shareSettings?.includes(SHARE_SETTINGS.RESHARE_ALLOWED) && !isUserPublicCase.value));

    const downloadUrl = computed(() => process.env.VUE_APP_MEDIA_URL + props.file.downloadUrl);

    function onShare() {
      if (!toShare.value) {
        return;
      }
      emit('on-click-share');
    }
    return {
      isNetwork,
      isMy,
      isCase,
      toShare,
      isPublicCasesPage,
      onShare,
      downloadUrl,
      isPublicPage,
    };
  },
});
